const Mission = () => {
  return (
    <div id="mission" className="basic-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="text-container">
              <h2>December 22nd 2020 at Innovation Hub Space</h2>
              <p>
                Our mission is to help people do better SEO. The team is excited
                to invite you to the next SEO Training Course session which
                undoubtedly will provide you with the necessary skills to
                improve your online presence. Fill out the form to register and
                we'll contact you in less than 24h
              </p>
              <a className="btn-solid-lg page-scroll" href="#contact">
                Contact
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;
